<template>
    <div class="header-nav">
        <div class="header-nav-block">
            <h1 class="header-nav-title section-title">КАТЕГОРИИ</h1>
        </div>

        <ul class="header-nav-ul">
            <li class="header-nav-li" :class="{ active: selectedCategory === null }">
                <p class="li-text-a" @click="selectCategory(null)">Все</p>
            </li>

            <li v-for="category in categories" :key="category.id" class="header-nav-li"
                :class="{ active: selectedCategory?.id === category.id }">
                <p class="li-text-a" @click="selectCategory(category)">{{ category.name }}</p>
            </li>

            <!-- Subcategories for mobile -->
            <li class="nuv-li-sub" v-if="selectedCategory?.sub_categories?.length">
                <p class="nuv-li-sub-a" @click="getProducts(selectedCategory.id)">Все</p>
                <p class="nuv-li-sub-a" v-for="sub in selectedCategory.sub_categories" :key="sub.id"
                    @click="getProducts(sub.id)">
                    {{ sub.name }}
                </p>
            </li>
        </ul>

        <!-- Subcategories for desktop -->
        <div class="sub-category" v-if="selectedCategory?.sub_categories?.length">
            <ul class="sub-category-ul">
                <li class="sub-category-li">
                    <p class="sub-category-a" @click="getProducts(selectedCategory.id)">Все</p>
                </li>
                <li class="sub-category-li" v-for="sub in selectedCategory.sub_categories" :key="sub.id">
                    <p class="sub-category-a" @click="getProducts(sub.id)">
                        {{ sub.name }}
                    </p>
                </li>
            </ul>
        </div>

        <div class="katalog-block">
            <product-item v-for="product in products" :key="product.id" :product="product" />
        </div>

        <div class="show-more-block">
            <a href="/catalog" class="show-more">Смотреть все</a>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const products = ref([])
const categories = ref([])
const selectedCategory = ref(null)

const getCategories = async () => {
    const { data } = await axios.get('/get-categories')
    categories.value = data.categories
}

const getProducts = async (id = null) => {
    const { data } = await axios.get('/get-products/' + (id || ''))
    products.value = data.products
}

const selectCategory = (category) => {
    selectedCategory.value = category
    getProducts(category?.id || null)
}

onMounted(() => {
    getCategories()
    getProducts()
})
</script>
<style scoped>
.header-nav {
    margin-top: 120px;

    @media screen and (max-width:500px) {
        margin-top: 170px;
    }
}

.header-nav-block {
    width: 100%;
    height: auto;
    align-items: center;
    margin: 20px 0 30px;

    @media screen and (max-width: 430px) {
        margin: 20px 0 18px
    }
}

.header-nav-title {
    font-size: 40px;
    text-align: center;
    color: #3c5757;
}

.header-nav-ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0 5px;
    gap: 10px;
    align-items: center;
    justify-content: center;
    color: white;

}

.header-nav-li {
    width: auto;
    min-width: 100px;
    height: 30px;
    border-radius: 5px;
    background-color: #3c5757;
    padding: 0 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 430px) {
        width: 100%;
        margin: 0 20px;
    }
}

.li-text-a {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.header-nav-li:hover {
    background-color: #e8cc0f;
    border: 1px solid #3c5757
}

.active {
    background-color: #e8cc0f;
    color: black;
    border: 1px solid #3c5757
}

.li-text-a:hover {
    color: #3c5757
}

.katalog-block {
    width: 100%;
    margin: 40px 0;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 25px;
    color: #3c5757
}

.katalog-single-block {
    max-height: 543px;
    width: 300px;
    cursor: pointer;
    border: 2px solid #3c5757;
    border-radius: 6px;

    &:hover {
        transform: scale(1.05);
        border: 2px solid #e8cc0f;
    }
}

.katalog-single-block-img {
    /* max-width: 300px; */
    width: 300px;
    height: 300px;
    max-width: 300px;
}

.katalog-single-block-buttom {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 3px
}

.single-block-kod-lopa {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #3c5757;
    padding: 10px
}

.katalog-single-block-name {
    text-wrap: wrap;
    font-size: 22px;
    font-weight: 900;
    color: #3c5757;
    text-align: center;
    margin-bottom: 2px;
}

.katalog-single-block-line {
    color: #3c5757;
    border-top: 2px solid #3c5757;
    padding: 4px 0;
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
}

.katalog-single-block-order {
    width: 180px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: #3c5757;
    color: #e8cc0f;
    align-self: center;
    gap: 7px
}

.katalog-single-block-order:hover {
    background-color: #e8cc0f;
    color: #3c5757;
    border: 1px solid #3c5757;
}

.show-more-block {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20px;
    color: #3c5757
}

.show-more {
    font-size: 20px;
    font-weight: 900;
    text-decoration: underline;
    color: #3c5757;

    &:focus {
        color: #e8cc0f
    }
}

.show-more:hover {
    color: #e8cc0f
}

.image-block-sale {
    position: relative;
}

.fa-tag {
    position: absolute;
    color: red;
    font-size: 60px;
    top: -6px;
    left: 90px;
    z-index: 10;
}

.fa-percentage {
    position: absolute;
    color: white;
    font-size: 26px;
    top: 10px;
    left: 112px;
    z-index: 11;
}

.fa-map-pin {
    position: absolute;
    top: -18px;
    left: 101px;
    color: #e8cc0f;
    font-size: 28px;
    z-index: 13;
    transform: rotate(32deg);
}

.fa-search-plus:hover {
    color: #e8cc0f;
    transition: calc(1.07);
}

.fa-search-plus:focus {
    color: #e8cc0f;
    transition: calc(1.07);
}

.popap {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100000;
    background-color: rgba(60, 87, 87, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 620px) {
        display: none;
    }

}

.popap-block {
    max-width: 700px;
    min-width: 600px;
    max-height: 700px;
    min-height: 600px;
    padding: 15px;
    background-color: aliceblue;
    opacity: 1;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    color: #3c5757;

    @media screen and (max-width: 778px) {
        max-width: 650px;
        min-width: 400px;
    }
}

/* .paper-img {
    border-radius: 6px;
} */

.fa-search-plus {
    @media screen and (max-width: 620px) {
        display: none;
    }
}

.close {
    align-self: flex-end;
    cursor: pointer;

    &:hover {
        color: #e8cc0f;
    }
}

.sub-category {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 430px) {
        display: none;
    }
}

.sub-category-ul {
    display: flex;
    gap: 10px
}

.sub-category-a {
    cursor: pointer;
    color: #3c5757;

    &:focus {
        text-decoration: underline;
    }
}

.sub-category-a:hover {
    text-decoration: underline;
}

.sub-category-li {
    &:not(:last-child) {
        position: relative;
        margin-right: 3px;
        padding-right: 15px;

        &::after {
            content: "/";
            font-family: var(--font-primary);
            font-size: 16px;
            position: absolute;
            right: 0;
            top: 2px;
            color: #3c5757;
        }
    }
}

.nuv-li-sub {
    display: none;

    @media screen and (max-width: 431px) {
        width: 100%;
        display: flex;
        flex-direction: column;
        border: 1px solid #3c5757;
        border-radius: 6px;
        margin: 0 20px;
        color: #3c5757;
        gap: 10px;
        padding: 10px
    }
}

.nuv-li-sub-a {

    &:hover {
        text-decoration: underline;
    }

    &:focus {
        text-decoration: underline;
    }
}
</style>